import {
  Briefcase,
  ClipboardText,
  BookBookmark,
  Users,
  Pencil,
  Archive,
  UsersFour,
  Browsers
} from '../Icons'

const types = {
  default: Archive,
  gestor: Briefcase,
  administrador: Briefcase,
  coordenador: ClipboardText,
  colaborador: UsersFour,
  professor: Pencil,
  aluno: BookBookmark,
  editor: Browsers,
  família: Users
}

export default types
